<template>
  <div class="go_home_box" @click="goToHome">
    <div class="go_home_btn">
      主页
    </div>
  </div>
</template>

<script>
export default {
  name: "GoHomeBtn",
  data() {
    return {

    }
  },
  mounted() {
    
  },
  methods: {
    goToHome(){
      this.$router.push('/')
    }
  },
};
</script>

<style lang="scss" scoped>
.go_home_box{
  background: url(@/assets/go_home_box.png) no-repeat;
  background-size: 100% auto;
  @apply fixed right-0 bottom-28;
  .go_home_btn{
    background: url(@/assets/goHome.png) no-repeat left top;
    background-size: 28px 28px;
    @apply my-px py-2 pr-3 pl-8 text-xs text-[#4C5BDF];
  }
}
</style>